// extracted by mini-css-extract-plugin
export var st0 = "oci-module--st0--1WBVd";
export var svgElem1 = "oci-module--svg-elem-1--g_Ai_";
export var active = "oci-module--active--227bx";
export var svgElem2 = "oci-module--svg-elem-2--3AZAz";
export var svgElem3 = "oci-module--svg-elem-3--2oIY6";